import React, { useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import DrawerModal from './DrawerModal';
import styled, { css } from 'styled-components/macro';
import { useNomenclator } from '../../contexts/nomenclatorContext';
import useIni from "../..//hooks/useIni";
import {
  nombreEleccion,
} from '../../resources/constantes.json';
import { useTranslate } from '../../contexts/languageContext';

/**
 * Drawer accesible que permite navegar entre las elecciones,
 * la página de inicio y la página de estadísticas.
 *
 */

const Drawer = withRouter(({ className, page, icon }) => {
  const [isOpen, setIsOpen] = useState(false);
	const t = useTranslate();
  const ini = useIni();
  const nomenclator = useNomenclator();
  const elections = computeElections(ini?.botones, nomenclator.nomAmbitos, nomenclator.ordAmbitos)
  return (
    <DrawerModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      icon={icon}
      className={className}
    >
      <nav>
        <ul>
          {elections.map(elec => (
            <StyledListItem selected={elec.page === page} key={elec.path}>
              <StyledLink
                selected={elec.page === page}
                onClick={() => setIsOpen(false)}
                to={elec.path}
              >
                {elec.name}
              </StyledLink>
            </StyledListItem>
          ))}
					<StyledListItem>
						<StyledLink
							target="_blank"
							rel="noopener noreferrer"
							to={{ pathname:"https://resultadosprecpresidente1v.registraduria.gov.co/presidente/0/colombia"}}
							>
							{t('resultadosPrimera')}
						</StyledLink>
					</StyledListItem>

        </ul>
      </nav>
    </DrawerModal>
  );
});

const computeElections = (iniButtons, ambitos, ordenAmbitos) => {
  const inicio = { path:'/inicio', name: 'Inicio', page: 'inicio'}
  const estadisticas = { path:'/estadisticas', name: 'Estadísticas', page: 'estadisticas'}
  const activeButtons = iniButtons.filter(b=> b.hab === 'activado').map(b => b.id)
  const activeAmbitos = Object.entries(ambitos).filter(([idx, amb]) => activeButtons.includes(String(idx)))
  const elections = activeAmbitos.map(([idx, amb]) => (
    { 
      id: idx,
      path: "/"+nombreEleccion[idx]+"/0/colombia", 
      name: amb.n, 
      page: nombreEleccion[idx] 
    }))
  elections.sort((a,b) => ordenAmbitos.indexOf(a.id) - ordenAmbitos.indexOf(b.id))
  elections.unshift(inicio);
  elections.push(estadisticas);
  return elections;
}

export default Drawer;

const StyledListItem = styled.li`
  position: relative;
  display: block;
  height:44px;
  ${({ selected }) =>
    selected &&
    css`
        background-color: #1C4183;
    `}
  &:hover {
    background-color: #1C4183;
  }
`;

const StyledLink = styled(Link)`
  box-sizing: border-box;
  font-weight: bold;
  font-size: 14px;
  text-transform: uppercase;
  text-decoration: none;
  width: 100%;
  height: 100%;
  display: block;
  padding-left: 20px;
  line-height: 44px;
  color: ${({ selected }) => (selected ?'#fff': '#1C4183' )};
  &:hover {
    text-decoration: none;
    color: #fff;
  }
`;
